import React, { useEffect } from 'react'
// import { Swiper, SwiperSlide } from 'swiper/react';
// import SwiperCore, { Navigation } from 'swiper';
// import tractor1 from '../../images/tractor-1.jpg'
// import tractor2 from '../../images/tractor-2.jpg'
// import tractor3 from '../../images/tractor-3.jpg'
// import 'swiper/swiper.scss';
// import 'swiper/components/navigation/navigation.scss';
import BrandSlider from './BrandSlider';
import { Tabs, Button } from 'antd';

const { TabPane } = Tabs;


// SwiperCore.use([Navigation]);

const viewAll = <Button type="primary" >View All</Button>;
// const swiperParams = {
//     slidesPerView: 1,
//     centeredSlides: false,
//     loop: false,
//     spaceBetween: 15,
//     shouldSwiperUpdate: true,
//     rebuildOnUpdate: true,
//     breakpoints: {
//         900: {
//             slidesPerView: 5,
//         },
//         700: {
//             slidesPerView: 4,
//         }
//     },
// }

function BrandSection() {
    return (
        <div className="mt-16">
            <div className="p-4 m-4 rounded-lg shadow bg-white">
                <div className="p-2">
                    <h2 className="text-2xl font-bold text-gray-700">Brands</h2>
                    
                    <Tabs defaultActiveKey="1" tabBarExtraContent={viewAll}>
                        <TabPane tab="Tractors" key="1">
                            <BrandSlider />
                        </TabPane>

                        <TabPane tab="Implements" key="2">
                            <BrandSlider />
                        </TabPane>

                    </Tabs>
                </div>
                
            </div>
            
            
        </div>
    );
}

export default BrandSection;
